import { useState } from 'react';
import FormField from '../../components/FormField';
import './styles/SignIn.scss'
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import Seo from '../../components/Seo';

export default function SignIn() {
    const[email, setEmail] = useState("");
    const[password, setPassword] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    // Where to return after login: the page that sent the user here (e.g. checkout), else the course.
    const from = (location.state as { from?: string } | null)?.from ?? "/kurz";

    const api = new ApiHelper();

    async function process() {
        try {
            let res = await api.userApi.loginCreate({username: email, password: password});
            let token = (await res.json()).token;
            localStorage.removeItem("token");
            localStorage.setItem("token", "Bearer " + token);
            navigate(from, { replace: true });
        } catch (x : any) {
            api.processErrors(x);
        }
    }

    return (
        <div className="signIn">
            <Seo title="Přihlášení" noindex />
            <div className="container" >
                <h1 className="title">
                    Přihlášení
                </h1>

                <FormField label="email" value={email} handle={setEmail} />
                <FormField label="heslo" value={password} handle={setPassword} password={true} />

                <div className="button" onClick={async () => await process()}>
                    <h2>
                        PŘIHLÁSIT SE
                    </h2>
                </div>
            </div>
        </div>
    );
}
